var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSpSpot(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "spSpot",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "spot"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_5541",
    "data-name": "\\u9577\\u65B9\\u5F62 5541",
    width: 24,
    height: 24,
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_5542",
    "data-name": "\\u9577\\u65B9\\u5F62 5542",
    width: 18,
    height: 18,
    transform: "translate(3 2)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_5267",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 5267",
    transform: "translate(4.999 2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_3024",
    "data-name": "\\u9577\\u65B9\\u5F62 3024",
    width: 2,
    height: 10,
    transform: "translate(4.134)",
    fill: "#666"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_3030",
    "data-name": "\\u9577\\u65B9\\u5F62 3030",
    width: 6,
    height: 1,
    transform: "translate(2.134)",
    fill: "#666"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_5799",
    "data-name": "\\u30D1\\u30B9 5799",
    d: "M9.978,11.282,1.751,6.532A3.5,3.5,0,0,1,5.251.47l8.227,4.75Z",
    transform: "translate(0 6.717)",
    fill: "#666"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpSpot);
export default __webpack_public_path__ + "static/media/spSpot.5b4d90deaeab8b42291cd3082d6d1ec4.svg";
export { ForwardRef as ReactComponent };